// package imports
import { Session } from 'next-auth';
import { KitButton } from 'components/common/cms-kit';

// local imports
import { MegaMenuSection } from '../SiteHeaderTypes';
import MobileMenuSection from './MobileMenuSection';
import useMediaQuery from 'hooks/useMediaQuery';

export type MainMenuItemProps = {
  section: MegaMenuSection;
  portalRef: React.RefObject<HTMLDivElement | null>;
  session: Session | null;
};

const MainMenuItem = (props: MainMenuItemProps) => {
  const { section, session } = props;
  const isLargerScreen = useMediaQuery('(min-width: 1084px)');
  const isButton = section?.fields?.displayAsButton === 'true';
  const isLoggedIn = session?.user !== undefined;
  let displayButton = false;
  if (isButton) {
    if (section.fields.notLoggedInUserOnlyDisplay === 'true' && !isLoggedIn) {
      displayButton = true;
    }
    if (section.fields.loggedInUserDisplayOnly === 'true' && isLoggedIn) {
      displayButton = true;
    }
  }

  if (displayButton) {
    return (
      <div className="inline-flex justify-center items-center relative">
        <KitButton
          color={section.fields.buttonColor ?? 'primary'}
          size="sm"
          round
          style={{
            width: isLargerScreen ? '143px' : '111px',
            height: isLargerScreen ? '48px' : '38px',

            color: '#fff',
          }}
        >
          <a
            href={section.fields?.links[0]?.fields?.link?.href}
            target={section.fields?.links[0]?.fields?.link?.target}
            rel="noopener noreferrer"
          >
            {section.fields.menuTitle}
          </a>
        </KitButton>
      </div>
    );
  }
  return <MobileMenuSection {...props} />;
};

export default MainMenuItem;
